import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";

// Life Campaign Service - Start a medical fundraiser (Life page form)
export const startLifeCampaign = async (data) => {
  try {
    const payload = {
      name: data.name?.trim() ?? "",
      email: data.email?.trim() ?? "",
      mobile: String(data.mobile ?? "").trim(),
      funds: data.funds ?? "",
      hospitalizationStatus: data.hospitalizationStatus ?? "",
    };

    const response = await axiosInstance.post(API_ENDPOINTS.LIFE_CAMPAIGN_START, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export default {
  startLifeCampaign,
};
